import { render, staticRenderFns } from "./ReferredCompaniesTable.vue?vue&type=template&id=8157aff6"
import script from "./ReferredCompaniesTable.vue?vue&type=script&lang=js"
export * from "./ReferredCompaniesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports